export default __webpack_public_path__ + "static/media/medium-logo-transparent-white.366ebadf.png";